module.exports = __webpack_public_path__ + "static/media/Nutrition2024_en.3b08a319.png";